<template>
  <div>
    <div v-if="isLoading" class="dark-overlay">
      <div class="lds-ripple">
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script>
import { oAuthApi } from '@/services/apis';
import localJwt from '@/services/local-jwt';

export default {
  name: 'SSO',
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    this.fetchToken();
  },
  methods: {
    redirectToBoards(boardID) {
      this.$router.replace(
        boardID
          ? { name: 'Boards-Id', params: { id: boardID } }
          : { name: 'Boards-List' }
      );
    },
    async fetchToken() {
      const query = this.$route?.query;
      this.isLoading = true;
      try {
        const res = await oAuthApi.token({
          grantType: 'oneTimeToken',
          code: query?.ott
        });
        if (res?.status == 200) {
          localJwt.setTokens(res.data);
          this.redirectToBoards(query?.boardID);
        }
      } catch {
        const getRedirectUri = query?.redirectURI;
        if (getRedirectUri)
          window.location.href = `https://${getRedirectUri}?error=sso`;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
